import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { hideVisually } from 'polished';

export const Label = styled.label`
  margin: 0;
`;

export const LabelText = styled.div`
    ${p => (p.hideLabel ? hideVisually() : null)} 
    color: ${p => p.theme.colors.lightFont};
    font-size: 1.125rem;
    font-weight: 500;
    line-height: 1.39;
    letter-spacing: 0.2px;
    margin-bottom: 10px;
`;

export const Required = styled.span`
  color: ${p => p.theme.colors.alert};
`;

export const Field = styled.input`
  background-image: ${p => (p.icon ? `url(${p.icon})` : 'none')};
  background-position: 10px 50%;
  background-repeat: no-repeat;
  background-size: 15px 15px;
  border-width: 1px;
  border-style: solid;
  border-color: ${p =>
    p.hasError
      ? p.theme.colors.error
      : p.isValid
        ? p.theme.colors.valid
        : p.theme.colors.border};
  line-height: 1;
  margin: 0;
  padding: 10px 10px 10px ${p => (p.icon ? '40px' : '10px')};
  width: 100%;
`;

export const ErrorMessage = styled.div`
  color: ${p => p.theme.colors.error};
  font-size: 0.875rem;
  margin-top: 5px;
`;

export default function Input({
  name,
  type,
  label,
  hideLabel,
  placeholder,
  icon,
  isRequired,
  value,
  error,
  touched,
  onChange,
  onBlur,
  ...rest
}) {
  return (
    <Label>
      <LabelText hideLabel={hideLabel}>
        {label} {isRequired && <Required>*</Required>}
      </LabelText>

      <Field
        {...rest}
        type={type}
        name={name}
        value={value}
        placeholder={placeholder}
        icon={icon}
        hasError={touched && error}
        isValid={touched && !error}
        required={false} //@todo: activate usRequired
        onChange={onChange}
        onBlur={onBlur}
      />

      {touched && error && <ErrorMessage>{error}</ErrorMessage>}
    </Label>
  );
}

Input.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
  label: PropTypes.string.isRequired,
  hideLabel: PropTypes.bool,
  placeholder: PropTypes.string,
  icon: PropTypes.string,
  isRequired: PropTypes.bool,
  value: PropTypes.string,
  error: PropTypes.string,
  touched: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func
};

Input.defaultProps = {
  type: 'text',
  hideLabel: false,
  placeholder: '',
  icon: '',
  isRequired: false,
  value: '',
  error: '',
  touched: false,
  isValid: false,
  onChange: () => { },
  onBlur: () => { }
};
